import styled from "styled-components/macro";

export const CrumbItem = styled.span``;

export default styled.ul`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  li {
    margin-right: 8px;
    &:not(:last-of-type) {
      &:after {
        content: ">";
        margin-left: 8px;
      }
    }
  }
`;
